// Short-lived token returned by /v1/auth/login when a password change is mandatory.
// Kept in sessionStorage (not the URL) so it never lands in browser history or server logs.
const STORAGE_KEY = 'gig.passwordChangeToken';

export function setPasswordChangeToken(token) {
    try {
        sessionStorage.setItem(STORAGE_KEY, token);
    } catch (error) {
        console.warn('Could not store password change token:', error);
    }
}

export function getPasswordChangeToken() {
    try {
        return sessionStorage.getItem(STORAGE_KEY);
    } catch (error) {
        return null;
    }
}

export function clearPasswordChangeToken() {
    try {
        sessionStorage.removeItem(STORAGE_KEY);
    } catch (error) {
        // Storage unavailable; nothing to clear.
    }
}
